import React from 'react';
import { useField } from 'formik';
import { XMarkIcon } from '@heroicons/react/24/solid';
import Tooltip from '@dashboard/components/Tooltip';
import { cn } from '@dashboard/lib/utils';

// Refocus the field in `onClear`: the button unmounts, so a keyboard clear would otherwise
// strand focus on the body.
export default function ClearFieldButton({ name, disabled, onClear, className }) {
  const [field, , helpers] = useField(name);
  if (disabled || String(field.value ?? '').length === 0) return null;

  return (
    <Tooltip label="Clear" asChild>
      <button
        type="button"
        aria-label="Clear"
        // A mouse click leaves focus in the field instead of moving it to the button.
        onMouseDown={event => event.preventDefault()}
        onClick={() => {
          helpers.setValue('');
          onClear?.();
        }}
        className={cn(
          'absolute right-1.5 flex rounded-md p-1 text-muted-foreground opacity-0 transition hover:bg-gray-100 dark:hover:bg-muted hover:text-foreground group-hover/clear:opacity-100 focus-visible:opacity-100',
          className,
        )}
      >
        <XMarkIcon className="size-4" />
      </button>
    </Tooltip>
  );
}
